<template>
  <div>
    <div class="row">
      <div class="col-sm-12">
        <div class="box">
          <div class="box-header b-b">
            <h5>Monthly Sales Report</h5>
            <small>Shows cumulative sales by month</small>
          </div>
          <div class="box-tool">
            <ul class="nav">
              <li class="nav-item inline dropdown">
                <a 
                  data-toggle="dropdown" 
                  class="btn btn-default">Export</a>
                <div class="dropdown-menu dropdown-menu-scale pull-right">
                  <span class="dropdown-header">Export As</span>
                  <a 
                    class="dropdown-item" 
                    @click.prevent="exportAsFile('CSV')">CSV</a>
                  <a 
                    class="dropdown-item" 
                    @click.prevent="exportAsFile('PDF')">PDF</a>
                </div>
              </li>
            </ul>
          </div>
          <div class="box-body">
            <vue-apex-charts
              :options="chartOptions"
              :series="chartSeries"
              height="400px"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import VueApexCharts from 'vue-apexcharts';

export default {
    components: {
        VueApexCharts,
    },

    props: {
        Currency: {
            type: String,
            default: 'RM',
        },
    },

    data() {
        return {
            loading: true,
            cash: [],
            credit_card: [],
            voucher: [],
            others: [],
            sales: [],
            xAxisSales: [],
        };
    },

    computed: {
        ...mapGetters(['yearFilter']),

        api() {
            return Laroute.route('franchise.report.monthly.getMonthlySummary', {
                id: this.outlet,
            });
        },

        outlet() {
            return this.$store.getters.activeOutlet;
        },

        chartOptions() {
            return {
                chart: {
                    toolbar: {
                        show: false,
                    },
                    zoom: {
                        enabled: false,
                    },
                },
                dataLabels: {
                    enabled: false,
                },
                colors: ['#0cc2aa', '#D10543', '#0C43C2', '#FF5733', '#AC0CC2'],
                stroke: {
                    width: [2, 1.2, 1.2, 1.2, 1.2],
                },
                markers: {
                    size: 5,
                },

                xaxis: {
                    categories: this.xAxisSales,
                },

                yaxis: [
                    {
                        seriesName: 'Sales',
                        axisTicks: {
                            show: true,
                        },
                        axisBorder: {
                            show: true,
                        },
                        title: {
                            text: 'Sales',
                        },
                        labels: {
                            formatter: value =>
                                `${this.Currency} ${numeral(value).format()}`,
                        },
                    },
                ],

                tooltip: {
                    enabled: true,
                    shared: false,
                    intersect: true,
                    x: {
                        show: true,
                    },
                    marker: {
                        show: true,
                        shape: 'circle',
                    },
                },
                legend: {
                    horizontalAlign: 'left',
                    offsetX: 40,
                },
            };
        },

        chartSeries() {
            return [
                {
                    name: 'Sales',
                    type: 'line',
                    data: this.sales,
                },
                {
                    name: 'Cash',
                    type: 'column',
                    data: this.cash,
                },
                {
                    name: 'Credit Card',
                    type: 'column',
                    data: this.credit_card,
                },
                {
                    name: 'Voucher',
                    type: 'column',
                    data: this.voucher,
                },
                {
                    name: 'Others',
                    type: 'column',
                    data: this.others,
                },
            ];
        },
    },

    watch: {
        outlet() {
            this.getSummary();
        },

        yearFilter(a, b) {
            if (a == b) return;
            this.getSummary();
        },
    },

    created() {},

    mounted() {
        this.getSummary();
        $(this.$el).tooltip({
            selector: '[data-toggle="tooltip"]',
        });
    },

    methods: {
        getSummary() {
            var that = this;
            this.loading = true;

            let options = {
                since_year: this.$store.getters.startYear.format(),
                until_year: this.$store.getters.endYear.format(),
            };

            this.$http.get(this.api, { params: options }).then(response => {
                var data = response.data;

                that.xAxisSales = data.graph_data.total_sales.map(obj =>
                    moment(obj.date).format('MMM'),
                );

                that.sales = data.graph_data.total_sales.map(obj => obj.total);
                that.cash = data.graph_data.total_sales.map(
                    obj => obj.cash_amount,
                );
                that.credit_card = data.graph_data.total_sales.map(
                    obj => obj.credit_card_amount,
                );
                that.voucher = data.graph_data.total_sales.map(
                    obj => obj.voucher_amount,
                );
                that.others = data.graph_data.total_sales.map(
                    obj => obj.other_amount,
                );

                this.loading = false;
            });
        },

        exportAsFile(type) {
            let url = Laroute.route(
                'franchise.report.monthly.exportGraphData',
                {
                    id: this.outlet,
                    type: type,
                },
            );
            let options = {
                since_year: this.$store.getters.startYear.format(),
                until_year: this.$store.getters.endYear.format(),
            };
            window.location.href = url + '?' + $.param(options);
        },

        formatNumber(number) {
            return numeral(number).format('0,0');
        },
    },
};
</script>

<style lang="scss" scoped>
.echarts {
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/monthly/vue_monthly.vue